import React, { useState, useEffect } from 'react';

import * as S from './styles';

type PhotoRankType = {
  rank?: number;
  small?: boolean;
  totalParticipatingUsers?: number;
};

const PhotoRank = ({
  rank,
  small,
  totalParticipatingUsers,
}: PhotoRankType): JSX.Element => {
  const [isSmall, setIsSmall] = useState(small);

  useEffect(() => {
    if (String(rank).length > 3) {
      setIsSmall(true);
    }
  }, [rank, small]);

  return (
    <S.Container>
      {rank && (
        <S.Circle className={isSmall ? 'small' : ''}>
          <S.Rank className={isSmall ? 'small' : ''}>
            {rank}
            <sup>e</sup>
          </S.Rank>
          {totalParticipatingUsers && (
            <S.TotalUsers className={isSmall ? 'small' : ''}>
              /{String(totalParticipatingUsers) || '-'}
            </S.TotalUsers>
          )}
        </S.Circle>
      )}
    </S.Container>
  );
};

export default PhotoRank;
